import React, { useState } from "react";
import './styles.scss';
import DATA from 'utils/data.json';
import Button from "components/button";

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';

const COURSE_DATA = DATA.course;

const Course = () => {
    const [currentWeek, setCurrentWeek] = useState(0);
    const [infoSwiper, setInfoSwiper] = useState(null);

    const onWeekClick = (weekIndex) => {
        setCurrentWeek(weekIndex)
        infoSwiper.slideTo(weekIndex, 200)
        document.getElementById(`weeks`).scrollLeft = (weekIndex) * 125
    }

    const onSlideChange = (data) => {
        setCurrentWeek(data.realIndex);
        document.getElementById(`weeks`).scrollLeft = (data.realIndex) * 125
    }

    return (
        <section id='course-id' className="course-block">
            <p className="title container">{COURSE_DATA.title}</p>
            <div className="sub-title-wrapper container">
                <img alt='' src={COURSE_DATA.icon} className='icon' />
                <p>{COURSE_DATA.subTitle}</p>
            </div>
            <div className="content">
                <div className="top">
                    <div className="course-detail">
                        <div id={'weeks'} className="weeks">
                            <div className="line"/>
                            {COURSE_DATA.list.map((item, index) => {
                                return (
                                    <button id={`week-${index}`} className="item" key={index} onClick={() => onWeekClick(index)}>
                                        <img alt="" src={`/images/icon-course-${index+1}.svg`} className='icon'/>
                                        <img alt='' src={currentWeek === index ? '/images/icon-course-active-week.svg' : '/images/icon-course-inactive-week.svg'} className='point'/>
                                        <p className={`text ${currentWeek === index ? 'active' : ''}`}>Tuần {item.week}</p>
                                    </button>
                                )
                            })}
                        </div>
                        <div className="course-content">
                            <Swiper
                                slidesPerView={1}
                                spaceBetween={15}
                                className='slide-info'
                                onSlideChange={onSlideChange}
                                onSwiper={setInfoSwiper}
                            >
                                {COURSE_DATA.list.map((item, index) => {
                                    return (
                                        <SwiperSlide key={index}>
                                            <div className="wrapper">
                                                <img alt='' src={`/images/icon-course-${index + 1}.svg`} className={'course-content__icon'} />
                                                <div className="course-content__content">
                                                    <p className="title">{item.title}</p>
                                                    {item.content.map((text, index) => {
                                                        return (
                                                            <p key={index}>{text}</p>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>

                        </div>
                    </div>
                    <div className="advise">
                        <p className="title">{COURSE_DATA.advise.title}</p>
                        <img alt='' src={COURSE_DATA.advise.icon} className='icon' />
                        <p className="sub-title">{COURSE_DATA.advise.subTitle}</p>
                        <p className="text">{COURSE_DATA.advise.text}</p>
                        <Button href={COURSE_DATA.advise.href} className="cta" content={COURSE_DATA.advise.cta} />
                    </div>
                </div>
                <div className="bottom container">
                    <div className="training">
                        <p className="bottom__title">{COURSE_DATA.training.title}</p>
                        <ul>
                            {COURSE_DATA.training.content.map((item, index) => {
                                return (
                                    <li key={index}><span dangerouslySetInnerHTML={{ __html: item }} /></li>
                                )
                            })}
                        </ul>
                    </div>
                    <div className="value">
                        <p className="bottom__title">{COURSE_DATA.value.title}</p>
                        <ul>
                            {COURSE_DATA.value.content.map((item, index) => {
                                return (
                                    <li key={index}><span dangerouslySetInnerHTML={{ __html: item }} /></li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Course